import React from 'react';
import { FormattedMessage } from 'react-intl';
import P from '../../../../../components/P';
import messages from '../../messages';
import Section from '../../../components/Section';
import ControlContainer from '../../../components/ControlContainer';
export default function AuthorizationCrum() {
  return (
    <div>
      <Section>
        <ControlContainer>
          <P style={{ fontWeight: 'bold' }}>
          AUTHORIZATION
          </P>
          <P>
          I hereby authorize Crum & Forster, United States Fire Insurance Company or its representative, to inspect or secure copies of case history records or any other data necessary to determine eligibility of benefits. I also authorize Crum & Forster, United States Fire Insurance Company or its representative to release and share claim information including that which may be used in the identification and prevention of potential fraudulent activity to any insurance organization, fraud information clearinghouses, designated service providers and business associates assisting in the processing of this claim. A photostatic copy or facsimile of this authorization shall be deemed as effective and valid as the original. This authorization is valid for twelve (12) months from date of signature. I HAVE REVIEWED AND ACKNOWLEDGE THE ATTACHED FRAUD WARNING.
          </P>
        </ControlContainer>
      </Section>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/AuthorizationCrum/index.js